import { render } from "./video.vue?vue&type=template&id=7e215e22"
import script from "./video.vue?vue&type=script&lang=js"
export * from "./video.vue?vue&type=script&lang=js"

import "./video.vue?vue&type=style&index=0&id=7e215e22&lang=css"
script.render = render

export default script